import { createContext } from "react";
import { DEFAULT_NUMBER_FORMAT_OPTIONS } from "./DefaultNumberFormatOptionsContext";
export const NumberFormatOptionsContext = createContext(DEFAULT_NUMBER_FORMAT_OPTIONS);
NumberFormatOptionsContext.displayName = "NumberFormatOptionsContext";
//# sourceMappingURL=NumberFormatOptionsContext.js.map